module.exports = __webpack_public_path__ + "img/Certificates.01b5a9e4.svg";